/*
Ashraf 01/31/2023 2698964415 fixed deleted sort fields ids
Akhila 03/03/2023 2698964415 bug fixed sort field delete record issue
Akhila 03/03/2023 2698964415 rename select Any one in sort field table
Sohel 04/17/2023 2698964415 Fixed Sort Field Issue
Ravi 05/31/2023 2698964415 changed delete popup message
Akhila 06/12/2023 2698964415 added role access
Ravi 05/31/2023 2698964415 disable Print Subtotal conditaionally
Ravi 07/19/2023 2698964415 hide print subtotal from table in Export Manager
*/

import React, {useRef, useState} from 'react';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import {
  FormControl,
  FormHelperText,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
} from '@material-ui/core';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';


const SubTotalsOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'NO'},
];
const SortOnOptions = [
  {key: 'N', value: 'Ascending'},
  {key: 'Y', value: 'Descending'},
];
const EditableDataTable = ({
  sortFields,
  setSortFields,
  sortFieldsDeleteIdsRef,
  editExisting,
  DataManagerAccess,
  type,
  disableSubTotal,
}) => {
  const [isDelete, setIsDelete] = useState(false);
  const deleteRef = useRef(null);

  const handleSortFieldChange = (i, property, value) => {
    const copyArr = [...sortFields];
    copyArr[i][property] = value;
    setSortFields(copyArr);
  };

  const reorderItems = (startIndex, endIndex) => {
    const arr = [...sortFields];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setSortFields(arr);
  };

  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };

  const handleDelete = (rowData, key) => {
    deleteRef.current = rowData;
    setIsDelete(true);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };

  const handleConfirmDelete = () => {
    const arr = sortFields.filter((r) => r.fieldName !== deleteRef.current.fieldName);
    if (deleteRef.current.reportSortFieldsId) {
      const newArr = sortFieldsDeleteIdsRef.current.filter(
        (el) => el !== deleteRef.current.reportSortFieldsId,
      );
      newArr.push(deleteRef.current.reportSortFieldsId);
      sortFieldsDeleteIdsRef.current = newArr;
    } else if (deleteRef.current.workqueueSortFieldId) {
      const newArr = sortFieldsDeleteIdsRef.current.filter(
        (el) => el !== deleteRef.current.workqueueSortFieldId,
      );
      newArr.push(deleteRef.current.workqueueSortFieldId);
      sortFieldsDeleteIdsRef.current = newArr;
    } else if (deleteRef.current?.dataManagerSortFieldsId) {
      const newArr = sortFieldsDeleteIdsRef.current.filter(
        (el) => el !== deleteRef.current.dataManagerSortFieldsId,
      );
      newArr.push(deleteRef.current.dataManagerSortFieldsId);
      sortFieldsDeleteIdsRef.current = newArr;
    }
    setSortFields(arr);
    handleCloseDialog();
  };

  // const handleCancel = (rowData, key) => {
  //   const arr = [...selectedRows];
  //   arr.forEach((ele) => {
  //     delete ele.deleteState;
  //   });
  //   setSelectedRows(arr);
  // };

  // const disabledByRole = roleData?.window?.["Record Format"]?.["RF"]?.add;
  // const disableDelete = roleData?.window?.["Record Format"]?.["RF"]?.delete;

  // const roleAccess = roleData?.window?.["Record Format"]?.["RF"];
  // const viewOnly = !roleAccess?.edit && !roleAccess?.add && roleAccess?.read && !roleAccess?.delete;

  const columns = [
    {
      title: 'Actions',
      field: 'actions',
    },
    {
      title: 'Seq',
      field: 'seq',
    },
    {
      title: 'Repository',
      field: 'repository',
    },
    {
      title: 'Field Name',
      field: 'fieldName',
    },

    {
      title: 'Sort Order',
    },
    {
      title: 'Print Subtotal',
      hidden: type === 'Export',
    },
  ];
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Field"
        value={`Are you sure you want to delete the ${deleteRef.current?.fieldName} Field?`}
        handleSubmit={handleConfirmDelete}
      />
      <div
        className={`new-standard-textfields  mui-custom-table-container custom-table  pt-0 global-field-table text-center-table`}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <table>
            <thead className="recFormat-header-container">
              <tr>
                {columns.map(
                  ({title, hidden = false}) =>
                    !hidden && (
                      <th key={title} className="recFormat-header">
                        {title}
                      </th>
                    ),
                )}
              </tr>
            </thead>
            <Droppable droppableId="droppabe-list">
              {(provided) => (
                <tbody ref={provided.innerRef} className="recFormat-body">
                  {sortFields?.length > 0 ? (
                    sortFields.map((rowData, index) => {
                      return (
                        <Draggable key={index} draggableId={'draggable-' + index} index={index}>
                          {(provided) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <td className="recFormat-col recFormat-center">
                                <Tooltip title="Delete">
                                  <IconButton
                                    disabled={editExisting && !DataManagerAccess?.edit}
                                    onClick={(e) => {
                                      handleDelete(rowData, index);
                                    }}
                                  >
                                    <DeleteOutlined />
                                  </IconButton>
                                </Tooltip>
                              </td>
                              <td className="recFormat-col global-field-textfields">{index + 1}</td>
                              <td className="recFormat-col global-field-textfields">
                                {rowData.repositoryName}
                              </td>
                              <td className="recFormat-col global-field-textfields report-table-textfields">
                                <div
                                  style={{
                                    width: '170px !important',
                                    margin: '0px auto !important',
                                  }}
                                >
                                  {rowData.fieldName}
                                  <FormHelperText error>{}</FormHelperText>
                                </div>
                              </td>

                              <td className="recFormat-col global-field-textfields report-table-textfields">
                                <div className="report-table-field">
                                  <FormControl margin="dense" variant="outlined" fullWidth>
                                    <Select
                                      name={'sortOrder' + index}
                                      className="select-gender"
                                      value={rowData.sortOrder || 'none'}
                                      onChange={(e) => {
                                        handleSortFieldChange(index, 'sortOrder', e.target.value);
                                      }}
                                    >
                                      <MenuItem value="none" key="none" disabled>
                                        <span className="defaultSelected"> Select Any</span>
                                      </MenuItem>
                                      {SortOnOptions.map((option) => {
                                        return (
                                          <MenuItem value={option.key} key={option.key}>
                                            {option.value}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                  <FormHelperText>
                                  </FormHelperText>
                                </div>
                              </td>
                              {type !== 'Export' &&
                              <td className="recFormat-col global-field-textfields field-2 report-table-textfields">
                                <div className="format-field report-table-field">
                                  <FormControl margin="dense" variant="outlined" fullWidth>
                                    <Select
                                      fullWidth
                                      name="printTotal"
                                      className="select-gender"
                                      required
                                      disabled={disableSubTotal}
                                      value={rowData.printTotal || 'none'}
                                      onChange={(event) => {
                                        handleSortFieldChange(
                                          index,
                                          'printTotal',
                                          event.target.value,
                                        );
                                      }}
                                    >
                                      <MenuItem value="none" key="none" disabled>
                                      Select Any
                                      </MenuItem>
                                      {SubTotalsOptions.map((option) => {
                                        return (
                                          <MenuItem value={option.key} key={option.key}>
                                            {option.value}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl>
                                </div>
                              </td>
                              }
                            </tr>
                          )}
                        </Draggable>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={columns.length}>
                        No records to display. To add Sort Fields to your record click the &quot;+ Sort
                        Fields&quot; button in the top right of this section.
                      </td>
                    </tr>
                  )}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    </>
  );
};

export default EditableDataTable;
